<template>
  <section class="file-rank-com">
    <div class="item file-r">
      <!-- <div class="file-title">热门文件 -->
      <!-- </div> -->
      <div class="file-list">
        <!-- <fileSimpleCard v-for="(item, index) in fileList" :key="index" :cardData="item"></fileSimpleCard> -->
        <el-carousel>
          <el-carousel-item v-for="(item, index) in fileList" :key="index">
            <img class="adImg" :src="item.photoUrl" >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </section>
</template>

<script>
import api from '../../../api/index'
// import fileSimpleCard from '@/components/fileSimpleCard.vue'
export default {
  data () {
    return {
      fileList: [],
      reportList: [],
      otherList: []
    }
  },
  mounted () {
    this.doGetFileRank()
  },
  methods: {
    // doGetFileRank () {
    //   api.getFileRank({
    //     pages: 16,
    //     pageNo: 1,
    //     type: 'file'
    //   }).then(res => {
    //     this.fileLoading = false
    //     if (res && res.code === 200) {
    //       this.fileList = res.data.list.filter((item) => {
    //         if (item.title.includes('环评工具箱')) {
    //           return false
    //         }
    //         return true
    //       })
    //     }
    //   })
    // }
    // 右侧广告
    doGetFileRank () {
      api.noticeAdvertising({
      }).then(res => {
        this.fileLoading = false
        if (res && res.code === 200) {
          this.fileList = res.data.list3
        }
      })
    }
  },
  components: {
    // fileSimpleCard
  }
}
</script>

<style lang="scss">
.file-rank-com {
  transform: translateY(10%);
  .file-title {
    font-size: 18px;
    color: #409eff;
  }
   & > .item {
     margin-bottom: 8px;
   }
  .file-list {
    .el-carousel__container {
      height: calc(100vh - 300px);
      .adImg {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
